<script setup>
import AuthLayout from '@/Layouts/AuthLayout.vue';
import { onMounted } from 'vue';
import { router } from '@inertiajs/vue3';

const props = defineProps({
  params: {
    type: Object,
    required: true,
  },
});

onMounted(() => {
  const apiPublic = props.params.api_public;

  const interval = setInterval(() => {
    axios
      .get(route('ccv.check-ready', apiPublic))
      .then(({ data }) => {
        if (data.is_ready) {
          clearInterval(interval);

          router.visit(route('ccv.install', props.params));
        }
      })
      .catch(response => console.log(response));
  }, 1000);
});
</script>

<template>
  <auth-layout>
    <div class="card-body form">
      <h1 class="">{{ trans('__JSON__.Preparing') }}...</h1>
      <p class="py-1 pb-2">{{ trans('__JSON__.APIcenter is processing the installation') }}</p>
      <p class="py-1 pb-2">{{ trans('__JSON__.You will be redirected once the installation is ready.') }}</p>
    </div>
  </auth-layout>
</template>
